import { AgentsPermissions } from "components/agents/permissions";
import RestorableModel from "libraries/restorableModel";

export const NewsroomPermissions = {
  canUpdateSharedValue: (reader: RestorableModel) => {
    return AgentsPermissions.canUpdateSharedValue(reader);
  }
};
